import { Services } from '@omnia/ui/src/lib/services/services'
import { cinemaService } from './cinema.service'
import { cmsDataService } from './cms.data.service'
import { cmsService } from './cms.service'
import { navigationService } from './navigation.service'
import { CineColombiaUrlService } from './url.service'

export const initServices = () => {
    Services.CmsDataService = cmsDataService
    Services.CmsService = cmsService as unknown as typeof Services.CmsService
    Services.NavigationService = navigationService as unknown as typeof Services.NavigationService
    Services.UrlService = new CineColombiaUrlService(navigationService) as unknown as typeof Services.UrlService
    Services.CinemaService = cinemaService

    // Sometimes there are issues accessing these services from within omnia/ui
    // possibly they are getting included in separate bundles and omnia/ui is referring to a different instance?
    // Assigning these to the window object makes them more accessible from anywhere
    window.CmsDataService = Services.CmsDataService
    window.CmsService = Services.CmsService
    window.NavigationService = Services.NavigationService
    window.UrlService = Services.UrlService
    window.CinemaService = Services.CinemaService
}
